import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'
import { sendDataBody } from '../../resources'
import { Button } from 'antd'

// PARENT: visitas.modal.jsx

// This component is used to add a soap form to visita.modal.jsx if the selected treatment is soap

export default function VisitaSoap({ id_paciente, setIsModalOpen }) {

    const [soaptext, setSoaptext] = useState('')
    const onFinish = () => {
        console.log('Ext ', soaptext)
        const body = {
            id_paciente,
            tipo_visita: 'Evolucion',
            soap: soaptext
        }
        sendDataBody('visitas/add', body).then(() => setIsModalOpen(false))
    }

    return (
        <div>
            <span>Nota de evolución</span>

            <TextArea value={soaptext} onChange={e => setSoaptext(e.target.value)} placeholder={`S\n\nO\n\nA\n\nP`} rows={8} />
            <br />
            <br />
            <div style={{ position: 'absolute', right: 16, bottom: 16 }}>
                <Button onClick={() => setIsModalOpen(false)} >Cancelar</Button>
                <Button type='primary' onClick={onFinish} >Enviar</Button>
            </div>
        </div>
    )
}
